<div class="access-denied-container">
  <img src="assets/logo-wm.png" alt="App Logo" class="app-logo" />
  <h1>Access Denied</h1>
  <p>You do not have permission to view this page.</p>
  <button mat-stroked-button color="primary" routerLink="/">Go to Home</button>  Or  <button mat-stroked-button color="primary" routerLink="/auth/login">Login</button>
</div>
